import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';
import { I18nService } from '@core/services/i18n.service';
import { PriceService } from '@core/services/price.service';
import { ReqService } from '@core/services/req.service';
import { SearchStateService } from '@core/services/search-state.service';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';
import { AmRewardsPricingComponent } from '@am/rewards-pricing';
import { MbRecommendedCard } from '@am/moebius';
import { SlicePipe } from '@angular/common';

@Component({
    selector: 'related-hotels',
    templateUrl: './related-hotels.component.html',
    styleUrls: ['./related-hotels.component.scss'],
    standalone: true,
    imports: [
        MbRecommendedCard,
        AmRewardsPricingComponent,
        SlicePipe,
        CurrencyPipe,
    ],
})
export class RelatedHotelsComponent implements OnInit, OnChanges {
  @Input()
  name: string;
  @Input()
  related: any;
  @Input()
  priceByValue: any;
  @Input()
  showAmountTotal: boolean;
  @Input()
  section: string;
  @Input()
  isLanding: boolean;
  @Input()
  hotelCountry: string;
  @Input()
  hotelCity: string;
  @Input()
  isMapView = false;

  public isAlliance: boolean;
  public quantityNights: number;
  public quantityRooms: number;
  public brandImage: string;
  private brandImages: Array<string> = ['avantrip'];
  private brand: string;

  constructor(
    private searchStateService: SearchStateService,
    private analyticsService: AnalyticsService,
    private i18nService: I18nService,
    private reqService: ReqService,
    private priceService: PriceService,
  ) {}

  ngOnInit() {
    this.brand = this.reqService.getBrand();
    if (this.brandImages.includes(this.brand)) {
      this.brandImage = `${this.brand}-hotel-no-image.svg`;
    } else {
      this.brandImage = `almundo-hotel-no-image.svg`;
    }
    this.isAlliance = this.reqService.isAlliance();
  }

  private getPriceTotalToShow(related) {
    if (related && related.rate && related.rate.price) {
      return this.priceService.getPrice(
        related.rate,
        this.priceByValue,
        this.showAmountTotal,
      );
    }
  }

  private getUrl(related) {
    let slugName = related.slug.split('-');
    const slugId = slugName.pop();
    slugName = slugName.join('-');
    let finalUrl = '';
    if (this.isLanding) {
      const firstSection = this.i18nService.translate('first-section');
      const sectionDetail = this.i18nService.translate('section-detail');
      finalUrl =
        '/' +
        firstSection +
        '/' +
        sectionDetail +
        '/' +
        slugName +
        '-' +
        this.searchStateService.getHashedId(slugId);
    } else {
      const query = this.searchStateService.getLocationSearch();
      const priceBy = this.searchStateService.getPriceBy()
        ? '&priceBy=' + this.searchStateService.getPriceBy()
        : '';
      let data = '';
      if (query.featuredHotelId) {
        data += '&featuredHotelId=' + query.featuredHotelId;
      }
      if (query.flexible) {
        data += '&flexible=' + query.flexible;
      }
      if (query.ratesFilterOption) {
        data += '&ratesFilterOption=' + query.ratesFilterOption;
      }
      if (query.withFullPrice) {
        data += '&withFullPrice=' + query.withFullPrice;
      }
      if (query.dynamicEnabled) {
        data += '&dynamicEnabled=' + query.dynamicEnabled;
      }
      if (query.PAYMENT_METHOD) {
        data += '&PAYMENT_METHOD=' + query.PAYMENT_METHOD;
      }
      if (query.theme) {
        data += '&theme=' + query.theme;
      }
      if (query.currencyCode) {
        data += '&currencyCode=' + query.currencyCode;
      }
      finalUrl =
        '/hotels/detail/' +
        slugName +
        '-' +
        this.searchStateService.getHashedId(slugId) +
        '?date=' +
        query.date +
        '&rooms=' +
        query.rooms +
        priceBy +
        data +
        '&origin=' +
        this.searchStateService.getEntityCode() +
        '&brand=' +
        this.brand;
    }
    return finalUrl;
  }

  public trackByItems(index, _item) {
    return index;
  }

  public openRelated(related) {
    if (!this.isMapView) {
      this.analyticsService.trackEvent({
        section: this.section,
        action: 'Related',
        label: 'Recomendados',
      });
      window.open(related.url, '_blank');
    }
  }

  public addImageHotel(images) {
    if (images && images.length > 0) {
      return images[0].url;
    } else {
      return `/hotels/dist/es-AR/browser/assets/images/${this.brandImage}`;
    }
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.quantityNights = this.priceService.totalNights;
    this.quantityRooms = this.priceService.totalRooms;

    this.related = this.related || [];
    if (this.related.length) {
      this.related.forEach((element) => {
        const url: string = this.getUrl(element);
        const priceTotalToShow: any = this.getPriceTotalToShow(element);
        element.url = url;
        element.priceTotalToShow = priceTotalToShow;
        element.superclubPrice = Math.ceil(priceTotalToShow);
      });
    }
  }
}
